
const comFooterContents = (() => {
  const jsFooter = (document.getElementById("jsFooter") != null);
  if (jsFooter) {



    let sW = window.innerWidth;

    const footer = document.getElementById('jsFooter');
    let cntntsWrap = footer.querySelector('.js-cntnts-wrap');
    let slideArea = cntntsWrap.querySelector('.js-slide-area');

    let swiperEl = slideArea.querySelector('.js-swiper');
    // let prevEl = slideArea.querySelector('.js-swiper-button-prev');
    // let nextEl = slideArea.querySelector('.js-swiper-button-next');
    // let paginationEl = slideArea.querySelector('.js-swiper-pagination');

    let setCenteredSlides
    if (sW > 768) {
      setCenteredSlides = false
    } else {
      setCenteredSlides = true
    }

    const swiper = new Swiper(swiperEl, {
      // effect: 'fade', // フェードモードにする（デフォルトは 'slide'）
      // fadeEffect: {
      //   crossFade: true, // クロスフェードを有効にする（フェードモードの場合 true 推奨）
      // },

      slidesPerView: 'auto', // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
      spaceBetween: 0, // スライド間の余白（px）
      centeredSlides: setCenteredSlides, // アクティブなスライドを中央に配置する

      loop: true,  // 無限ループさせる
      loopAdditionalSlides: 1, // 無限ループさせる場合に複製するスライド数

      speed: 1000, // スライドアニメーションのスピード（ミリ秒）

      autoplay: { // 自動再生させる
        delay: 5000, // 次のスライドに切り替わるまでの時間（ミリ秒）
        disableOnInteraction: false, // ユーザーが操作しても自動再生を止めない
        waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
      },

      // grabCursor: true, // PCでマウスカーソルを「掴む」マークにする
      // watchSlidesProgress: true, // スライドの進行状況を監視する

      // pagination: {
      //   el: paginationEl, // ページネーション要素のクラス
      //   clickable: true, // クリックによるスライド切り替えを有効にする
      //   type: 'bullets' // 'bullets'（デフォルト） | 'fraction' | 'progressbar'
      // },

      // navigation: {
      //   nextEl: nextEl, // 「次へ」ボタン要素のクラス
      //   prevEl: prevEl, // 「前へ」ボタン要素のクラス
      // },

      // scrollbar: {
      //   el: '.swiper-scrollbar', // スクロールバー要素のクラス
      // },

      // thumbs: {
      //   swiper: mySwiper2 // サムネイルのスライダーのインスタンス名
      // },

      // breakpoints: { // ブレークポイント
      //   600: { // 画面幅600px以上で適用
      //     slidesPerView: 2,
      //   },
      //   1025: { // 画面幅1025px以上で適用
      //     slidesPerView: 4,
      //     spaceBetween: 32,
      //   }
      // },

      // on: { // イベントを登録する
      //   slideChange: (swiper) => {
      //     console.log('Slide index changed to: ' + (swiper.realIndex + 1));
      //   },
      // },
    });

    swiper.autoplay.stop();



    if (document.querySelector("body#pageTop") !== null) {
      swiper.slideToLoop(2)
    }
    if (document.querySelector("body#pageRedevelopment") !== null) {
      swiper.slideToLoop(2)
    }
    if (document.querySelector("body#pageDesign") !== null) {
      swiper.slideToLoop(3)
    }
    if (document.querySelector("body#pageAccess") !== null) {
      swiper.slideToLoop(4)
    }
    if (document.querySelector("body#pagePlan") !== null) {
      swiper.slideToLoop(5)
    }
    if (document.querySelector("body#pageType") !== null) {
      swiper.slideToLoop(5)
    }
    if (document.querySelector("body#pagePremiumplan") !== null) {
      swiper.slideToLoop(5)
    }
    if (document.querySelector("body#pageEquipment") !== null) {
      swiper.slideToLoop(6)
    }
    if (document.querySelector("body#pageCompanies") !== null) {
      swiper.slideToLoop(7)
    }



    ScrollTrigger.create({
      invalidateOnRefresh: true,
      trigger: '#jsFooter .js-slide-area',
      start: 'top center',
      onEnter: () => swiper.autoplay.start(),
      // markers: true,
    });



  }
})();
export default comFooterContents;